import { memo } from 'react';

import { Tooltip } from '@air/primitive-tooltip';

import { type IconType } from '~/types/icons';

type InfoPanelCameraDetailsItemProps = {
  text: string | number;
  Icon: IconType;
  label: string;
};

export const InfoPanelCameraDetailsItem = memo(({ text, Icon, label }: InfoPanelCameraDetailsItemProps) => {
  return (
    <div className="flex gap-1">
      <Tooltip label={label} side="left">
        <Icon className="size-4 ads:text-icon-subtle text-gray-8" />
      </Tooltip>
      <p className="ads:text-primary text-12 text-gray-12">{text}</p>
    </div>
  );
});

InfoPanelCameraDetailsItem.displayName = 'InfoPanelCameraDetailsItem';
